import { useState } from 'react';

import type { PopAccuracyComfortSectionHighlightData } from '../types';
import DesktopHighlightsAccordion from './DesktopHighlightsAccordion';

export interface DesktopHighlightsProps {
  readonly highlights: PopAccuracyComfortSectionHighlightData[];
}

const DesktopHighlights = ({ highlights }: DesktopHighlightsProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const handleActiveIndexChange = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div
      className="mt-auto hidden flex-col gap-y-10 md:js:flex"
      data-cy="pop-accuracy-comfort-section-highlights-desktop"
    >
      {highlights.map((highlight, i) => (
        <DesktopHighlightsAccordion
          activeIndex={activeIndex}
          highlight={highlight}
          index={i}
          key={highlight.title}
          onChange={handleActiveIndexChange}
        />
      ))}
    </div>
  );
};

export default DesktopHighlights;
